<template>
  <div>
      <DelenquentTaxReport />
  </div>
</template>

<script>
import DelenquentTaxReport from '../../../../components/tax/TaxInquiry/Reports/DelinquentTaxReports.vue';

export default {
  name: 'delinquentTaxReports',
  components: {
    DelenquentTaxReport,
  },
};

</script>
